import React, { useEffect, useState } from "react";
import { get } from "lodash";
import {
    PaymentElement,
    useStripe,
    useElements,
} from '@stripe/react-stripe-js';

import { useNavigate } from "react-router-dom";
import { Button } from "../../../../components/Field";
import { showToast } from "../../../../helpers/notify";
import { scrollToTop } from "../../../../helpers/animation";
import AsyncGet from "../../../../components/AsyncGet";

import style from "../style.module.css";

export default function CheckoutForm(props) {
    const {
        couponId = "",
        planId = "",
        userId = "",
        personalDetails = {},
        setPaymentError,
        paymentError = {},
        paymentIntentDetails = {},
        nextStep,
        total = 0,
        color = "buttonDefault",
        from="register",
        autoRenewal=true,
        setStep=null,
        planType,
    } = props;
    
    const stripe = useStripe();
    const elements = useElements();
    const navigate = useNavigate();
    const [isCardComplete, setIsCardComplete] = useState(false);
    const [loading, setLoading] = useState(false);
    const [sendError, setSendError] = useState(false);
    const [sendSuccess, setSendSuccess] = useState(false);
    const [paymentIntent, setPaymentIntent] = useState({});
    let setTotal = paymentIntentDetails.totalAmount ? paymentIntentDetails.totalAmount : total;

    let successApiUrl = "";
    if(from === "changepaymentmethod") {
        successApiUrl = "/payment/method-change";
    }
    else if(from === "renewmembership") {
        successApiUrl = "/membership/renew-membership";
    }
    else if(from === "changeplan") {
        successApiUrl = `/membership/confirm-payment/${planId}`;
    }

    useEffect(() => {
        if (elements) {
            const paymentElement = elements.getElement(PaymentElement);
            if (paymentElement) {
                paymentElement.on('change', (event) => {
                    setIsCardComplete(event.complete);
                });
            }
        }
    }, [elements]);

    const paymentElementOptions = {
        layout: "tabs"
    };

    const handlePaymentSubmission = async (event) => {
        event.preventDefault();
        setLoading(true);
        setPaymentError("");

        if (!stripe || !elements) {
            return;
        }

        const { error, paymentIntent } = await stripe.confirmPayment({
            elements,
            confirmParams: {
                return_url: "https://ww2headquarters.com/",
            },
            redirect: 'if_required',
        });
        setLoading(false);

        if (error) {
            setPaymentError(error);
            setSendError(Date.now());
        } else {
            setPaymentIntent(paymentIntent)
            setSendSuccess(Date.now());
        }
    };

    return (
        <>
            <AsyncGet
                url="/payment/payment-error-log"
                permissionText={false}
                loadOnMount={sendError}
                method="post"
                paramsData={{
                    user_id: personalDetails.id ? personalDetails.id : userId,
                    coupon_id: couponId,
                    plan_id: planId,
                    paymentIntentId: paymentIntentDetails.paymentIntentId,
                    stripe_error: paymentError
                }}
            />
            {
                from === "register" && (
                    <AsyncGet
                        url="/payment/confirm-payment"
                        permissionText={false}
                        loadOnMount={sendSuccess}
                        method="post"
                        paramsData={{
                            user_id: personalDetails.id,
                            coupon_id: couponId,
                            plan_id: planId,
                            paymentIntentId: paymentIntentDetails.paymentIntentId,
                            payment_type: get(paymentIntent, 'payment_method_types', ''),
                            auto_renewal: autoRenewal,
                            stripe_response: paymentIntent,
                        }}
                        onFetch={({ data }) => {
                            if(get(data, 'user_id', '') !== "") {
                                nextStep('Congratulations');
                                scrollToTop();
                            }
                        }}
                    />
                )
            }
            {
                (from === "changepaymentmethod" || from === "renewmembership" || from === "changeplan") && (
                    <AsyncGet
                        url={successApiUrl}
                        permissionText={false}
                        loadOnMount={sendSuccess}
                        method="post"
                        paramsData={{
                            stripe_response: paymentIntent,
                            coupon_id: couponId,
                            plan_type: planType
                        }}
                        onFetch={({ data }) => {
                            if(data) {
                                if(from === "changepaymentmethod"){ 
                                    showToast(data.message);
                                    navigate('/profile');
                                }
                                else if(from === "changeplan") {
                                    window.location.reload();
                                }
                                else {
                                    showToast(data.message);
                                    setStep("step4");
                                }
                            }
                        }}
                    />
                )
            }
            <form onSubmit={handlePaymentSubmission}>
                <div className={style.checkoutFormWrap}>
                    <PaymentElement options={paymentElementOptions} />
                </div>
                <div className={style.form}>
                    <div className={`${style.formRow} ${style.formSubmit} ${style[from]}`}>
                        <Button
                            size="full"
                            submit={true}
                            label={`Pay £${setTotal}`}
                            disabled={!stripe || !isCardComplete}
                            fetching={loading}
                            color={color}
                        />
                        {
                            (from === "changepaymentmethod" || from === "renewmembership" || from === "register" || from === "changeplan") && (
                                <Button
                                    color="buttonPrimaryWithOutBg"
                                    link="/profile"
                                    label="Cancel"
                                />
                            )
                        }
                    </div>
                </div>
            </form>
        </>
    );
}